import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import { setPassiveTouchGestures } from "@polymer/polymer/lib/utils/settings";

import { defineElement } from "../../utility/defineElement.js";
import { template } from "./lag-barcodescanner.html.js";

import Quagga from "@ericblade/quagga2";
defineElement(class extends PolymerElement {
    static get is() { return "lag-barcodescanner"; }
    static get template() { return template; }
    static get properties () {
        return {
            _codeReader: { Type: Object },
            _selectedCameraIdx: { Type: Number },
            _availableCameras: { Type: Array },
            _elementId: { Type: String },
            _currentOrientationAngle: { Type: Number }
        };
    }

    constructor() {
        // If you override the constructor, always call the
        // superconstructor first.
        super();
        // Resolve warning about scroll performance
        // See https://developers.google.com/web/updates/2016/06/passive-event-listeners
        setPassiveTouchGestures(true);
    }

    ready(){
        super.ready();
    }

    initialize(elementId) {
        this._elementId = elementId;

        Quagga.init({
            locate: true,
            inputStream: {
                name: "Live",
                type: "LiveStream",
                target: this.$.interactive,
                constraints: {
                    facingMode: "environment",
                    width: { min: window.innerWidth },
                    height: { min: window.innerHeight },
                },
                area: {
                    top: "0%",
                    right: "0%",
                    left: "0%",
                    bottom: "0%",
                },
                singleChannel: false
            },
            decoder: {
                readers: [
                    "code_128_reader",
                    "code_39_reader",
                    "code_39_vin_reader"
                ],
                debug: {
                    drawBoundingBox: true,
                    showFrequency: true,
                    drawScanline: true,
                    showPattern: true
                },
            },
            locator: {
                halfSample: true,
            }
        }, (err) => {
            if (err) {
                console.error(err);
                return;
            }

            Quagga.onDetected((result) => {
                const event = new CustomEvent("code-scanned", { detail: { eleId: this._elementId, result: result.codeResult.code } });
                this.dispatchEvent(event);
            });
            Quagga.start();
            
        });
    }

    stopCapture() { Quagga.stop(); }
});
